import api from "api"

export async function loadUserState(store) {
  await store.actions.loadUser()
  const user = store.getState("user")
  if (user.id != null) {
    const { group_type, group_id } = user
    let currentHouseholdId = ""
    await store.actions.loadUserHouseholdIds(group_id)
    if (group_type !== "advisor") {
      currentHouseholdId = group_id
    } else {
      currentHouseholdId = store.getState("householdIds", group_id)[0]
    }

    const householdIdFromLocalStorage = api.getUserPersistantData(
      user.id,
      "currentHouseholdId"
    )

    await store.actions.updateHouseholdState({
      id: householdIdFromLocalStorage || currentHouseholdId,
      isNotWorking: false
    })

    await store.actions.updateUserState({
      currentHouseholdId: householdIdFromLocalStorage || currentHouseholdId
    })
  } else {
    await store.update(state => {
      state.userState = {}
    })
  }
}

export async function updateUserState(store, values) {
  await store.update(state => {
    Object.keys(values).forEach(key => (state.userState[key] = values[key]))
  })
}

export async function updateUser(store, values) {
  const user = await api.patch("user", {}, values)
  await store.update(state => {
    state.user = user
  })
}

export async function loadUser(store) {
  let user
  if (api.hasAuthToken()) {
    try {
      user = await api.get(`user`)
    } catch (error) {
      user = {}
    }
  } else {
    user = {}
  }
  await store.update(state => {
    state.user = user
  })
}

export async function setCurrentHouseholdId(store, household_id) {
  if (!household_id) {
    household_id = store.getState("householdIds")[
      store.getState("user", "group_id")
    ][0]
  }
  api.setUserPersistantData(
    store.getState("user").id,
    "currentHouseholdId",
    household_id
  )
  await store.actions.updateUserState({
    currentHouseholdId: household_id
  })
}

export async function signupUser(store, signupData) {
  const channel_id = signupData.channel_id || store.meta.channelId
  const { next_url } = await api.post(
    `auth/signup`,
    {},
    {
      app_id: store.meta.appId,
      ...signupData,
      channel_id
    }
  )
  if (window && window.gtag) {
    window.gtag("event", "sign_up", {
      event_category: "engagement",
      event_label: channel_id
    })
  }
  await store.actions.finalizeSignin(next_url)
}

export async function updateSubscription(store, group_id, updateData) {
  const subscription = await api.patch(
    `user/groups/${group_id}/subscription`,
    {},
    updateData
  )
  if (window && window.gtag) {
    window.gtag("event", "upgrade", {
      event_category: "engagement",
      event_label: updateData.plan_id
    })
  }
  await store.update(state => {
    state.subscriptions[group_id] = subscription
  })
}

export async function enableMfaSms(store, phone) {
  const response = await api.post(
    "user/mfa/sms/enable",
    {},
    {
      phone
    }
  )
  return response
}

export async function confirmEnableMfaSms(
  store,
  confirmationId,
  code,
  deviceId
) {
  const response = await api.post(
    `user/mfa/sms/enable/${confirmationId}`,
    {},
    {
      confirmation_code: code,
      ...(deviceId && { device_id: deviceId })
    }
  )

  if (response.length > 0) {
    await store.update(state => {
      state.user.mfa_type = "sms"
    })
  }

  return response
}

export async function disableMfaSms(store) {
  const response = await api.post(`user/mfa/sms/disable`, {}, {})
  return response
}

export async function confirmDisableMfaSms(
  store,
  confirmationId,
  code,
  deviceId
) {
  const response = await api.post(
    `user/mfa/sms/disable/${confirmationId}`,
    {},
    {
      security_code: code,
      ...(deviceId && { device_id: deviceId })
    }
  )

  if (response.status === "success") {
    await store.update(state => {
      state.user.mfa_type = null
    })
  }
}

export async function requestChanges(store, { type, value }) {
  const confirmationId = await api.post(
    `user/changes`,
    {},
    {
      field: type,
      [type]: value
    }
  )

  return { confirmationId }
}

export async function confirmChanges(store, code, confirmationId) {
  const user = await api.post(
    `user/changes/${confirmationId}`,
    {},
    {
      confirmation_code: code
    }
  )

  await store.update(state => {
    state.user = user
  })
}
